// extracted by mini-css-extract-plugin
export default {"wrapper":"IB-z","viewport":"JB-z","container":"KB-z","slide":"LB-z"};